import { createShowcaseBoxStyle } from "../../styles/showcase";
import { Link } from "wouter";

const SpinnerComponents = () => {
	const boxStyle = createShowcaseBoxStyle(1);
	const textos = {
		titulo_texto: {
			uno: "Spinner One",
			dos: "Spinner Two",
			tres: "Spinner Three",
			cuatro: "Spinner Four",
			cinco: "Spinner Five",
			seis: "Spinner Six",
		},
	};

	return (
		<div className="flex flex-col gap-y-10">
			<div className={boxStyle.padre}>
				<h2 className={boxStyle.subtitulo}>Normal Spinners:</h2>
				{/* Spinner 1 */}
				<div className={boxStyle.hijo}>
					<h2 className={boxStyle.titulo}>{textos.titulo_texto.uno}</h2>
					<div className="mx-4 border rounded-xl p-4"/>
					<p className="text-xs text-center text-balance ">
						copy code{" "}
						<Link href="/PagesResources">
							<a className="underline underline-offset-2 text-sky-400 hover:text-sky-700">Just Here</a>
						</Link>
					</p>
				</div>
			</div>
			{/* ///////////////////////////////////// */}
		</div>
	);
};
export default SpinnerComponents;


